import * as yup from "yup";

export const kommunerSchema = yup.object({
	kommunenavn: yup.string().required(),
	kommunenummer: yup.string().required()
});

export type Kommuner = yup.Asserts<typeof kommunerSchema>;
